<template>
  <div class="date-range-picker">
    <a-date-picker
      :value="startValue"
      @change="handleStartChange"
      :disabled-date="disabledStartDate"
      show-time format="YYYY-MM-DD HH:mm:ss"
      :placeholder="$t('dtrp.Start')"
      @openChange="handleStartOpenChange"
    />
    <a-date-picker
      :value="endValue"
      @change="handleEndChange"
      :disabled-date="disabledEndDate"
      show-time
      format="YYYY-MM-DD HH:mm:ss"
      :placeholder="$t('dtrp.End')"
      :open="endOpen"
      @openChange="handleEndOpenChange"
    />
  </div>
</template>
<script>
import moment from 'moment';

/**
 * Normalizes a date value to a moment instance or null
 * @param {*} value - Can be a moment instance, string, or null/undefined
 * @returns {moment.Moment|null}
 */
function normalizeDateValue(value) {
  if (!value) return null;
  
  try {
    if (typeof value === 'string') {
      const m = moment(value);
      return m.isValid() ? m : null;
    }
    if (moment.isMoment(value) && value.isValid()) {
      return value;
    }
    if (value instanceof Date) {
      const m = moment(value);
      return m.isValid() ? m : null;
    }
    return value;
  } catch (error) {
    console.warn('DateTimeRangePicker: Error normalizing date value', error);
    return null;
  }
}

export default {
  name: 'DateTimeRangePicker',
  props: {
    modelValue: {
      type: Array,
      default: () => [null, null]
    }
  },
  data() {
    return {
      endOpen: false,
    };
  },
  computed: {
    isValidModelValue() {
      return this.modelValue && Array.isArray(this.modelValue) && this.modelValue.length === 2;
    },
    startValue() {
      return this.isValidModelValue ? normalizeDateValue(this.modelValue[0]) : null;
    },
    endValue() {
      return this.isValidModelValue ? normalizeDateValue(this.modelValue[1]) : null;
    },
  },
  methods: {
    handleStartChange(date) {
      const normalizedDate = normalizeDateValue(date);
      const endDate = this.endValue;
      
      if (normalizedDate && endDate && normalizedDate.valueOf() > endDate.valueOf()) {
        return;
      }
      
      this.$emit('update:modelValue', [normalizedDate, endDate]);
    },
    handleEndChange(date) {
      const normalizedDate = normalizeDateValue(date);
      const startDate = this.startValue;
      
      if (normalizedDate && startDate && normalizedDate.valueOf() < startDate.valueOf()) {
        return;
      }
      
      this.$emit('update:modelValue', [startDate, normalizedDate]);
    },
    disabledStartDate(startValue) {
      const endValue = this.endValue;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue;
      if (!endValue || !startValue) {
        return false;
      }
      return endValue.valueOf() < startValue.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
  },
};
</script>
<style lang="scss">
.ant-calendar-time .ant-calendar-footer  {
  .ant-calendar-time-picker-btn, .ant-calendar-today-btn  {
    color: #1890ff;
  }
}
.date-range-picker {
  display: flex;
  gap: 10px;

  span {
    width: 100%;
  }

  @media (max-width: 768px) {
    width: 100%;
    flex-wrap: wrap;

    span {
      width: 100%;
      min-width: 100% !important;
    }
  }
}
</style>